export default {
	setCurrentMonth: (state, newVal) => {
		state.currentMonth = newVal;
	},

	setDatepickerStartDate: (state, newVal) => {
		state.datepickerStartDate = newVal ? new Date(newVal) : null;
	},
	setDatepickerEndDate: (state, newVal) => {
		state.datepickerEndDate = newVal ? new Date(newVal) : null;
	},

	setCurrentFocusedDate: (state, newVal) => {
		state.currentFocusedDate = newVal;
	},

	setDatepickerLoading: (state, bool) => {
		state.datepickerLoading = bool;
	},

	setAvailableStartDateResponses: (state, newResponsesObj) => {
		state.availableStartDateResponses = newResponsesObj;
	},
	setAvailableEndDateResponses: (state, newResponsesObj) => {
		state.availableEndDateResponses = newResponsesObj;
	},
};
